export const EMPLOYEES_TAG = 'EMPLOYEES_TAG';
export const EMPLOYEE_STATUS_TAG = 'EMPLOYEE_STATUS_TAG';
export const EMPLOYEE_TAG = 'EMPLOYEE_TAG';
export const TEMPLATE_TAG = 'TEMPLATE_TAG';
export const COMPANY_TAG = 'COMPANY_TAG';
export const SINGLE_COMPANY_TAG = 'COMPANY_TAG';
export const CUSTOMERS_TAG = 'CUSTOMERS_TAG';
